import styled from "styled-components";

export const StyledVote = styled.div`
  .description {
    margin: 8px 0;
  }

  .users-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .chosen {
    background-color: #71cb98;
    color: black;
  }
`;